import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
} from '@backstage/theme';
import GeistFont400 from '../assets/fonts/Geist/webfonts/Geist[wght].woff2';
import GeistMonoFont400 from '../assets/fonts/GeistMono/webfonts/GeistMono[wght].woff2';

const geistFont400 = {
  fontFamily: 'Geist Sans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Geist Sans'),
    url(${GeistFont400}) format('woff2'),
  `,
};

const geistMonoFont400 = {
  fontFamily: 'Geist Mono',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Geist Mono'),
    url(${GeistMonoFont400}) format('woff2'),
  `,
};

export const CausewayTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: '#690095',
      },
      secondary: {
        main: '#31135E',
      },
      error: {
        main: '#C63339',
      },
      warning: {
        main: '#FFD25B',
      },
      info: {
        main: '#4B20BC',
      },
      success: {
        main: '#048F6D',
      },
      background: {
        default: '#F4F0FC',
        paper: '#F8F9FE',
      },
      errorBackground: '#C63339',
      warningBackground: '#FFD25B',
      infoBackground: '#4B20BC',
      successBackground: '#048F6D',
    },
  }),
  fontFamily: 'Geist Sans',
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@font-face': [geistFont400, geistMonoFont400],
        'font-size': '16px',
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '100px',
        },
      },
    },
    BackstageHeader: {
      styleOverrides: {
        header: () => ({
          width: '100%',
          display: 'flex',
          padding: '24px',
          zIndex: '100',
          position: 'relative',
          gridArea: 'pageHeader',
          boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
          alignItems: 'center',
          flexDirection: 'row',
          backgroundSize: 'cover',
          backgroundImage: "url(data:image/svg+xml;charset=utf-8;base64,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), linear-gradient(90deg, #690095, #690095)",
          backgroundPosition: 'center',
        }),
      },
    },
    BackstageItemCardHeader: {
      styleOverrides: {
        root: () => ({
          color: '#fff',
          padding: '16px 16px 24px',
          backgroundSize: 'inherit',
          backgroundPosition: 0,
          backgroundImage: "url(data:image/svg+xml;charset=utf-8;base64,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), linear-gradient(90deg, #690095, #690095) !important",
        }),
      },
    },
  },
  defaultPageTheme: 'home'
});
